module.exports = __webpack_public_path__ + "static/img/mycs.af2ccb37.jpg";